/**
 * @title Comments page
 * @description The page shown when the consumer tells the story about the items
 */
import {useRecoilState, useRecoilValue} from "recoil";
import {ReturnsCartAtom} from "../returns/ReturnsCart";
import * as React from "react";
import {useEffect, useState} from "react";
import {PrivateRenderer} from "../PrivateRenderer";
import {StyledDiv, StyledTypography} from "../../../providers/layout/LayoutProvider";
import {LocalizationsAtom} from "../../../providers/localization/LocalizationProvider";
import {ReturnsPagePath} from "../returns/ReturnsPage";
import {CommentData, CommentItemData, CommentsForm} from "./CommentsForm";
import {Box} from "@mui/material";

export const CommentsPagePath = () => {
   return ReturnsPagePath() + "/comments";
}

export const CommentsPage = () => {
   const localizations = useRecoilValue(LocalizationsAtom);
   const [formData, setFormData] = useState<CommentData | null>(null);
   const [cart, setCart] = useRecoilState(ReturnsCartAtom);

   useEffect(() => {
      setFormData({
         items: cart.potentials.map(potential => {
            return {
               potentialId: potential._id,
               comment: cart.comments.find(c => c.potentialId === potential._id)?.comment || '',
               image: potential.imageUrls?.[0],
               name: potential.name,
               size: potential.size,
               color: potential.color
            } as CommentItemData
         }) || [],
         commentsAccept: false
      })
   }, [cart.comments, cart.potentials]);

   const onSave = async (data: CommentData) => {
      setCart({
         ...cart,
         comments: data.items.map(item => {
            return {
               potentialId: item.potentialId,
               comment: item.comment
            }
         })
      });
   }

   return <PrivateRenderer step={"comments"} swirlOnSubmit={true}>
      <StyledDiv type={"main"}>
         <Box sx={{
            margin: 'auto',
            width: '100%',
            textAlign: 'center',
            marginBottom: '30px'
         }}>
            <StyledTypography variant={"h1"}>
               {localizations.commentsPageTitle}
            </StyledTypography>
            <StyledTypography variant={"body1"}>
               {localizations.commentsPageDescription}
            </StyledTypography>
         </Box>
         <Box>
            {formData && <CommentsForm onSave={onSave} data={formData}/>}
         </Box>
      </StyledDiv>
   </PrivateRenderer>
}
